import '../css/add_new_client_page.css'
import React, { useContext, useEffect, useState, useRef  } from "react";
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { Tags } from "./Tags"
import { ButtonWIcon } from './Inputs'

const AddNewClient_p2 = () => {
    // Your component logic here

    const { id } = useParams()
    const navigate = useNavigate();
    const tagsSaveRef = useRef();

    function handleNextStepClick() {
        //navigate(`/add_new_client/p3/${id}`)
        callSaveTags()
        navigate(`/add_new_client/p3/${id}`)
    }

    function callSaveTags(){
        tagsSaveRef.current.handleSave();
    }
    
    return (
        <div className='add-new-client-page'>
            <div className='header'>
                <h1>Vytvoření nového klienta</h1>
                <p>(krok 2/3)</p>
            </div>
            <section className='section-1'>
                <div className='sub-section sub-section-1'>
                    <h4>Štítky</h4>
                    <Tags client_id={id} tagsSaveRef={tagsSaveRef} create_user_page={true} />

                    <div className='control-bar'>
                        
                        <ButtonWIcon iconSrc={"/img/svg/next.svg"} text={"Další krok"}
                            style={{ backgroundColor: "#795BF3", color: "white" }}
                            onClick={handleNextStepClick} />
                    </div>
                </div>
                <div className='sub-section sub-section-2'>

                </div>

            </section>
        </div>
    );
};

export default AddNewClient_p2;